import { giphyDarkGrey } from '@giphy/js-brand'
import styled, { css } from 'styled-components'
import DndComponent from './dnd'

const pinned = css`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

export const Container = styled.div`
    background: ${giphyDarkGrey};
    border-radius: 4px;
    position: relative;
`

export const Dnd = styled(DndComponent)`
    left: 0;
    position: absolute;
    top: 0;
`

export const Gradient = styled.div`
    ${pinned}
    border-radius: inherit;
    overflow: hidden;

    &:before,
    &:after {
        ${pinned}
        content: '';
    }

    &:before {
        background: linear-gradient(90deg, rgba(255, 255, 255, 255), rgba(255, 255, 255, 0));
    }

    &:after {
        background: linear-gradient(0deg, rgba(0, 0, 0, 255), rgba(0, 0, 0, 0));
    }
`
